import { MenuEntry } from './types'
import { faUserCircle, faList, faUsers, faQuestion, faPowerOff } from '@fortawesome/pro-duotone-svg-icons'

export const getUserMenuEntries = (kedo: any, onClose: () => void, handleLogoutClick: () => void): MenuEntry[] => {
    const entries: MenuEntry[] = []

    entries.push({
        to: '/profile',
        label: kedo.t('My profile'),
        icon: faUserCircle,
        onClick: onClose,
    })

    if (kedo.isAdmin()) {
        entries.push({
            to: '/subscriptions',
            label: kedo.t('Subscriptions'),
            icon: faList,
            onClick: onClose,
        })
    }

    entries.push({
        to: '/colleagues',
        label: kedo.t('Colleagues'),
        icon: faUsers,
        onClick: onClose,
    })

    entries.push({
        to: '/contact',
        label: kedo.t('Contact'),
        icon: faQuestion,
        onClick: onClose,
    })

    entries.push({
        label: kedo.t('Logout'),
        icon: faPowerOff,
        onClick: handleLogoutClick,
    })

    return entries
}